import { InfiniteList } from "@tiffin/components";
import { DateFormat, IOrderExt, OrderStatus } from "@tiffin/core";
import { CustomerOrderCard } from "./CustomerOrderCard";
import { IonBadge, IonIcon, IonItem } from "@ionic/react";
import { checkmarkCircle, flame } from "ionicons/icons";
import moment from "moment";

import "./CustomerOrderList.scss"

interface ICustomerOrderListProps {
  loading: boolean,
  orders: IOrderExt[],
  fetchMore: () => void,
  hasMore: boolean,
  refresh: () => void,
  hideViewStoreBtn?: boolean,
  messageCallback: () => void
}

export function CustomerOrderList(props: ICustomerOrderListProps) {

  const sortPendingOrdersFn = (a: IOrderExt, b: IOrderExt) => {
    if(a.time !== "now" && b.time !== "now") {
      return moment(a.time).valueOf() - moment(b.time).valueOf()
    } else if(a.time === "now") {
      return moment(a.date, DateFormat).startOf('day').valueOf() - moment(b.time).valueOf()
    } else if(b.time === "now") {
      return moment(a.time).valueOf() - moment(b.date, DateFormat).startOf('day').valueOf()
    }
    return 0;
  }

  const sortCompletedOrdersFn = (a: IOrderExt, b: IOrderExt) => {
    if(a.time !== "now" && b.time !== "now") {
      return moment(b.time).valueOf() - moment(b.time).valueOf()
    } else if(b.time === "now") {
      return moment(b.date, DateFormat).endOf('day').valueOf() - moment(a.time).valueOf()
    } else if(a.time === "now") {
      return moment(b.time).valueOf() - moment(a.date, DateFormat).endOf('day').valueOf()
    }
    return 0;
  }

  function renderOrderCards() {
    let cards: JSX.Element[] = []
    if(props.orders.length > 0) {
      const pendingOrders = props.orders.filter((order) => order.status === OrderStatus.Unconfirmed || order.status === OrderStatus.Confirmed || order.status === OrderStatus.Ready).sort((a,b) => sortPendingOrdersFn(a,b))
      cards.push(<div key="pending-order-header" className="group-header"><IonIcon className="pending-icon" icon={flame} /><span>Pending orders</span><IonBadge color="medium">{pendingOrders.length}</IonBadge></div>)
      for(let order of pendingOrders) {
        cards.push(
          <IonItem key={order.id}>
            <CustomerOrderCard order={order} hideViewStoreBtn={props.hideViewStoreBtn} messageCallback={props.messageCallback} />
          </IonItem>
        )
      }
      const completedOrders = props.orders.filter((order) => order.status !== OrderStatus.Unconfirmed && order.status !== OrderStatus.Confirmed && order.status !== OrderStatus.Ready).sort((a,b) => sortCompletedOrdersFn(a,b))
      
      cards.push(<div key="completed-order-header" className="group-header"><IonIcon className="completed-icon" icon={checkmarkCircle} /><span>Completed orders</span><IonBadge color="medium">{completedOrders.length}</IonBadge></div>)
      for(let order of completedOrders) {
        cards.push(
          <IonItem key={order.id}>
            <CustomerOrderCard order={order} hideViewStoreBtn={props.hideViewStoreBtn} messageCallback={props.messageCallback} />
          </IonItem>
        )
      }

    } else if(!props.loading) {
      cards.push(
        <IonItem key={'no-orders'}>
          <div className="no-orders">
            <span>You have no current or past orders</span>
          </div>
        </IonItem>
      )
    }

    return cards
  }
  
  return (
    <div className="customer-order-list">
      <InfiniteList 
        loading={props.loading}
        hasMore={props.hasMore}
        fetchMore={props.fetchMore}
        refresh={props.refresh}
      >
        {renderOrderCards()}
      </InfiniteList>
    </div>
  )
}